import React, { useState } from "react";
import ProfileTab from "./ProfileTab";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../utils/AuthProvider";
import { ToastContainer } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

export default function UserPage() {
  const location = useLocation();
  const { userLevel } = location.state || "";
  const { darkMode } = location.state || "false";
  const { logout, token, setUserLevel } = useAuth();

  const [activeSection, setActiveSection] = useState("Profile");
  const [user, setUser] = useState(JSON.parse(sessionStorage.getItem("user")));

  const getFirst = (name) => {
    return name.charAt(0).toUpperCase();
  };

  return (
    <div
      className={`flex flex-col min-h-screen  md:flex-row ${
        darkMode ? "bg-gray-800 text-white" : "bg-white text-black"
      }`}>
      <aside
        className={`flex flex-col justify-between w-full p-6  shadow-md md:w-1/4 ${
          darkMode ? "bg-gray-900" : "bg-slate-100"
        }`}>
        <div>
          <div className="flex flex-col items-center">
            <Link
              to="/app"
              alt="Back"
              className={`flex self-start px-4 py-2 font-semibold  rounded-md  ${
                darkMode
                  ? "bg-gray-900 text-gray-300 hover:bg-red-700"
                  : "bg-slate-100 text-gray-700 hover:bg-red-300"
              }`}>
              <FontAwesomeIcon
                icon={faArrowLeft}
                className="size-5"
              />
            </Link>
            <div className="flex items-center justify-center w-20 h-20 mb-2 text-2xl font-bold text-white bg-green-500 rounded-full">
              {getFirst(user.first_name)}
            </div>
            <h2 className="mb-4 text-xl font-semibold">
              {user.first_name + " " + user.last_name}
            </h2>
          </div>
          <nav className="mt-4">
            {["Profile"].map((section) => (
              <div
                key={section}
                className={`p-3 rounded-lg text-lg font-medium cursor-pointer mb-2 ${
                  activeSection === section
                    ? "bg-green-300 text-green-900"
                    : "hover:bg-slate-100 text-gray-700"
                }`}
                onClick={() => setActiveSection(section)}>
                {section}
              </div>
            ))}
          </nav>
        </div>
        <div
          className={`pt-6 border-t-2 ${
            darkMode ? "border-gray-700" : "border-gray-400"
          }`}>
          <button
            onClick={logout}
            className="w-full p-3 text-white bg-red-500 rounded-lg hover:bg-red-600">
            Logout
          </button>
        </div>
      </aside>

      <main
        className={`flex-grow p-8 mt-6  rounded-lg shadow-md md:mt-0 md:ml-6 ${
          darkMode ? "bg-gray-900" : "bg-slate-100"
        }`}>
        {activeSection === "Profile" && (
          <ProfileTab
            setActiveSection={setActiveSection}
            logout={logout}
            token={token}
            user={user}
            userLevel={userLevel}
            setUserLevel={setUserLevel}
            darkMode={darkMode}
          />
        )}
        {/* {activeSection === "Payments" && <PaymentsTab />} */}
      </main>
      <ToastContainer />
    </div>
  );
}
